import React, {Component} from 'react';
import PropTypes from 'prop-types';
import i18n from "../../i18n";
import axios from 'axios';
import {remove, isEmpty} from 'lodash';
import swal from 'sweetalert';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import {withStyles} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Fade from '@material-ui/core/Fade';

const styles = theme => ({
    form: {
        marginTop: theme.spacing.unit * 2,
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    progress: {
        margin: theme.spacing.unit * 2,
    },
    placeholder: {
        height: 20,
    }
});

class FileUploadForm extends Component
{
    constructor(props) {
        super(props);
        this.state = {
            file: null
        }
    };

    static propTypes = {
        accept: PropTypes.string.isRequired,
        lang: PropTypes.string.isRequired,
        route: PropTypes.string.isRequired,
    };

    handleClickLoading = () => {
        this.setState(state => ({
            loading: !state.loading,
        }));
    };

    onChange(e) {
        this.setState({file:e.target.files[0]});
    }

    async onSubmit(e) {
        e.preventDefault();
        let res = await this.uploadFile(this.state.file);
        console.log(res.data);
    }

    async uploadFile(file) {
        const formData = new FormData();

        formData.append('avatar', file);
        return await axios.post(this.props.route, formData, {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }).then(() => {
            window.location.reload();
        })
    }

    render() {

        const { classes } = this.props;
        const { loading } = this.state;

        return (
            <form className={classes.form} onSubmit={ this.onSubmit.bind(this) }>
                <input type="file" onChange={ this.onChange.bind(this) } />

                <Button type="submit" variant="contained" onClick={this.handleClickLoading}>
                    <Icon id='importerIcon' className={classes.leftIcon}>cloud_upload</Icon>
                    {i18n.get(this.props.lang, 'importers')}
                </Button>
                <div className={classes.placeholder}>
                    <Fade in={loading} style={{transitionDelay: loading ? '800ms' : '0ms'}} unmountOnExit >
                        <CircularProgress/>
                    </Fade>
                </div>
            </form>
        )
    }
}

export default withStyles(styles)(FileUploadForm);


// WEBPACK FOOTER //
// ./resources/assets/js/components/Uploader/FileUploadForm.jsx